<template>
    <nav class="sidebar" :class="{ collapsed: !isSidebarOpen }">

        <!-- Header: logo + hamburger toggle -->
        <div class="sidebar-header">
            <img class="sidebar-logo" :src="require('../assets/images/WSP_Block_OnDark 1.png')" />
            <button class="toggle-btn" @click="toggleSidebar" title="Toggle menu">
                <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 448 512"><path d="M0 96C0 78.3 14.3 64 32 64l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 128C14.3 128 0 113.7 0 96zM0 256c0-17.7 14.3-32 32-32l384 0c17.7 0 32 14.3 32 32s-14.3 32-32 32L32 288c-17.7 0-32-14.3-32-32zM448 416c0 17.7-14.3 32-32 32L32 448c-17.7 0-32-14.3-32-32s14.3-32 32-32l384 0c17.7 0 32 14.3 32 32z"/></svg>
            </button>
        </div>

        <!-- Nav body -->
        <div class="sidebar-body">
            <ul>

                <!-- Dashboard -->
                <li>
                    <a href="/">
                        <span class="nav-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M0 256a256 256 0 1 1 512 0A256 256 0 1 1 0 256zM288 96a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM256 416c35.3 0 64-28.7 64-64c0-17.4-6.9-33.1-18.1-44.6L366 161.7c5.3-12.1-.2-26.3-12.3-31.6s-26.3 .2-31.6 12.3L257.9 288c-.6 0-1.3 0-1.9 0c-35.3 0-64 28.7-64 64s28.7 64 64 64zM176 144a32 32 0 1 0 -64 0 32 32 0 1 0 64 0zM96 288a32 32 0 1 0 0-64 32 32 0 1 0 0 64zm352-32a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" /></svg></span>
                        <span class="nav-text">Dashboard</span>
                    </a>
                </li>

                <li class="nav-divider"></li>

                <!-- Search group -->
                <li class="group-header" @click="toggleGroup('search')">
                    <span class="nav-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg></span>
                    <span class="nav-text">Search</span>
                    <span class="chevron" :class="{ open: openGroups.search }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>
                </li>
                <li class="sub-item" v-show="openGroups.search">
                    <a href="/users/search">
                        <span class="sub-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 640 512"><path d="M144 0a80 80 0 1 1 0 160A80 80 0 1 1 144 0zM512 0a80 80 0 1 1 0 160A80 80 0 1 1 512 0zM0 298.7C0 239.8 47.8 192 106.7 192l42.7 0c15.9 0 31 3.5 44.6 9.7c-1.3 7.2-1.9 14.7-1.9 22.3c0 38.2 16.8 72.5 43.3 96c-.2 0-.4 0-.7 0L21.3 320C9.6 320 0 310.4 0 298.7zM405.3 320c-.2 0-.4 0-.7 0c26.6-23.5 43.3-57.8 43.3-96c0-7.6-.7-15-1.9-22.3c13.6-6.3 28.7-9.7 44.6-9.7l42.7 0C592.2 192 640 239.8 640 298.7c0 11.8-9.6 21.3-21.3 21.3l-213.3 0zM224 224a96 96 0 1 1 192 0 96 96 0 1 1 -192 0zM128 485.3C128 411.7 187.7 352 261.3 352l117.3 0C452.3 352 512 411.7 512 485.3c0 14.7-11.9 26.7-26.7 26.7l-330.7 0c-14.7 0-26.7-11.9-26.7-26.7z" /></svg></span>
                        <span class="nav-text">Search Users</span>
                    </a>
                </li>
                <li class="sub-item" v-show="openGroups.search">
                    <a href="/orders/search">
                        <span class="sub-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M64 64C28.7 64 0 92.7 0 128l0 64c0 8.8 7.4 15.7 15.7 18.6C34.5 217.1 48 235 48 256s-13.5 38.9-32.3 45.4C7.4 304.3 0 311.2 0 320l0 64c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-64c0-8.8-7.4-15.7-15.7-18.6C541.5 294.9 528 277 528 256s13.5-38.9 32.3-45.4c8.3-2.9 15.7-9.8 15.7-18.6l0-64c0-35.3-28.7-64-64-64L64 64zm64 112l0 160c0 8.8 7.2 16 16 16l288 0c8.8 0 16-7.2 16-16l0-160c0-8.8-7.2-16-16-16l-288 0c-8.8 0-16 7.2-16 16zM96 160c0-17.7 14.3-32 32-32l320 0c17.7 0 32 14.3 32 32l0 192c0 17.7-14.3 32-32 32l-320 0c-17.7 0-32-14.3-32-32l0-192z" /></svg></span>
                        <span class="nav-text">Search Orders</span>
                    </a>
                </li>

                <li class="nav-divider"></li>

                <!-- Competitions -->
                <li>
                    <a href="/competitions">
                        <span class="nav-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M256 512A256 256 0 1 0 256 0a256 256 0 1 0 0 512zm50.7-186.9L162.4 380.6c-19.4 7.5-38.5-11.6-31-31l55.5-144.3c3.3-8.5 9.9-15.1 18.4-18.4l144.3-55.5c19.4-7.5 38.5 11.6 31 31L325.1 306.7c-3.2 8.5-9.9 15.1-18.4 18.4zM288 256a32 32 0 1 0 -64 0 32 32 0 1 0 64 0z" /></svg></span>
                        <span class="nav-text">Competitions</span>
                    </a>
                </li>

                <li class="nav-divider"></li>

                <!-- Reports group -->
                <li class="group-header" @click="toggleGroup('reports')">
                    <span class="nav-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M304 240l0-223.4c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16L304 240zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4L256 288 412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288l238.4 0z" /></svg></span>
                    <span class="nav-text">Reports</span>
                    <span class="chevron" :class="{ open: openGroups.reports }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>
                </li>
                <li class="sub-item" v-show="openGroups.reports">
                    <a href="/reports">
                        <span class="sub-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M304 240l0-223.4c0-9 7-16.6 16-16.6C443.7 0 544 100.3 544 224c0 9-7.6 16-16.6 16L304 240zM32 272C32 150.7 122.1 50.3 239 34.3c9.2-1.3 17 6.1 17 15.4L256 288 412.5 444.5c6.7 6.7 6.2 17.7-1.5 23.1C371.8 495.6 323.8 512 272 512C139.5 512 32 404.6 32 272zm526.4 16c9.3 0 16.6 7.8 15.4 17c-7.7 55.9-34.6 105.6-73.9 142.3c-6 5.6-15.4 5.2-21.2-.7L320 288l238.4 0z" /></svg></span>
                        <span class="nav-text">Reports</span>
                    </a>
                </li>
                <li class="sub-item" v-show="openGroups.reports">
                    <a href="/reports/user-cap">
                        <span class="sub-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M416 208c0 45.9-14.9 88.3-40 122.7L502.6 457.4c12.5 12.5 12.5 32.8 0 45.3s-32.8 12.5-45.3 0L330.7 376c-34.4 25.2-76.8 40-122.7 40C93.1 416 0 322.9 0 208S93.1 0 208 0S416 93.1 416 208zM208 352a144 144 0 1 0 0-288 144 144 0 1 0 0 288z"/></svg></span>
                        <span class="nav-text">User Cap Report</span>
                    </a>
                </li>

                <li class="nav-divider"></li>

                <!-- Winners & Entries group -->
                <li class="group-header" @click="toggleGroup('winners')">
                    <span class="nav-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L24 64C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9L192 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-26.1 0C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24L446.4 64c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6l84.4 0c-5.1 66.3-31.1 111.2-63 142.3z" /></svg></span>
                    <span class="nav-text">Winners &amp; Entries</span>
                    <span class="chevron" :class="{ open: openGroups.winners }"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 320 512"><path d="M310.6 233.4c12.5 12.5 12.5 32.8 0 45.3l-192 192c-12.5 12.5-32.8 12.5-45.3 0s-12.5-32.8 0-45.3L242.7 256 73.4 86.6c-12.5-12.5-12.5-32.8 0-45.3s32.8-12.5 45.3 0l192 192z"/></svg></span>
                </li>
                <li class="sub-item" v-show="openGroups.winners">
                    <a href="/winners">
                        <span class="sub-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M400 0L176 0c-26.5 0-48.1 21.8-47.1 48.2c.2 5.3 .4 10.6 .7 15.8L24 64C10.7 64 0 74.7 0 88c0 92.6 33.5 157 78.5 200.7c44.3 43.1 98.3 64.8 138.1 75.8c23.4 6.5 39.4 26 39.4 45.6c0 20.9-17 37.9-37.9 37.9L192 448c-17.7 0-32 14.3-32 32s14.3 32 32 32l192 0c17.7 0 32-14.3 32-32s-14.3-32-32-32l-26.1 0C337 448 320 431 320 410.1c0-19.6 15.9-39.2 39.4-45.6c39.9-11 93.9-32.7 138.2-75.8C542.5 245 576 180.6 576 88c0-13.3-10.7-24-24-24L446.4 64c.3-5.2 .5-10.4 .7-15.8C448.1 21.8 426.5 0 400 0zM48.9 112l84.4 0c9.1 90.1 29.2 150.3 51.9 190.6c-24.9-11-50.8-26.5-73.2-48.3c-32-31.1-58-76-63-142.3zM464.1 254.3c-22.4 21.8-48.3 37.3-73.2 48.3c22.7-40.3 42.8-100.5 51.9-190.6l84.4 0c-5.1 66.3-31.1 111.2-63 142.3z" /></svg></span>
                        <span class="nav-text">Winners</span>
                    </a>
                </li>
                <li class="sub-item" v-show="openGroups.winners">
                    <a href="/bonus-winners">
                        <span class="sub-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M316.9 18C311.6 7 300.4 0 288.1 0s-23.4 7-28.8 18L195 150.3 51.4 171.5c-12 1.8-22 10.2-25.7 21.7s-.7 24.2 7.9 32.7L137.8 329 113.2 474.7c-2 12 3 24.2 12.9 31.3s23 8 33.8 2.3l128.3-68.5 128.3 68.5c10.8 5.7 23.9 4.9 33.8-2.3s14.9-19.3 12.9-31.3L438.5 329 542.7 225.9c8.6-8.5 11.7-21.2 7.9-32.7s-13.7-19.9-25.7-21.7L381.2 150.3 316.9 18z"/></svg></span>
                        <span class="nav-text">Bonus Winners</span>
                    </a>
                </li>
                <li class="sub-item" v-show="openGroups.winners">
                    <a href="/credit-and-entries">
                        <span class="sub-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 576 512"><path d="M64 64C28.7 64 0 92.7 0 128l0 256c0 35.3 28.7 64 64 64l448 0c35.3 0 64-28.7 64-64l0-256c0-35.3-28.7-64-64-64L64 64zM272 192l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16s7.2-16 16-16zM256 304c0-8.8 7.2-16 16-16l224 0c8.8 0 16 7.2 16 16s-7.2 16-16 16l-224 0c-8.8 0-16-7.2-16-16zM64 208a48 48 0 1 1 96 0A48 48 0 1 1 64 208z"/></svg></span>
                        <span class="nav-text">Credit &amp; Entries</span>
                    </a>
                </li>
                <li class="sub-item" v-show="openGroups.winners">
                    <a href="/users/bulk-credit">
                        <span class="sub-icon"><svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 512 512"><path d="M64 32C28.7 32 0 60.7 0 96l0 320c0 35.3 28.7 64 64 64l384 0c35.3 0 64-28.7 64-64l0-320c0-35.3-28.7-64-64-64L64 32zm96 96l64 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-64 0c-17.7 0-32-14.3-32-32s14.3-32 32-32zM96 288c0-17.7 14.3-32 32-32l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32zm32 96l256 0c17.7 0 32 14.3 32 32s-14.3 32-32 32l-256 0c-17.7 0-32-14.3-32-32s14.3-32 32-32z"/></svg></span>
                        <span class="nav-text">Bulk Credit Upload</span>
                    </a>
                </li>

            </ul>
        </div>

    </nav>
</template>

<script lang="ts">
    import { defineComponent, reactive, ref, watch, onMounted } from 'vue';

    export default defineComponent({
        name: 'SideBarNav',
        setup() {
            const isSidebarOpen = ref(true);

            onMounted(() => {
                document.body.classList.remove('sidebar-collapsed');
            });

            watch(isSidebarOpen, (val) => {
                if (val) {
                    document.body.classList.remove('sidebar-collapsed');
                } else {
                    openGroups.search = false;
                    openGroups.reports = false;
                    openGroups.winners = false;
                    document.body.classList.add('sidebar-collapsed');
                }
            });

            const openGroups = reactive({
                search: false,
                reports: false,
                winners: false,
            });

            function toggleGroup(group: keyof typeof openGroups) {
                openGroups[group] = !openGroups[group];
            }

            function toggleSidebar() {
                isSidebarOpen.value = !isSidebarOpen.value;
            }

            return { openGroups, toggleGroup, isSidebarOpen, toggleSidebar };
        },
    });
</script>

<style scoped>

    /* ── Sidebar shell ───────────────────────────────────── */
    .sidebar {
        position: fixed;
        top: 0;
        left: 0;
        width: 270px;
        height: 100vh;
        display: flex;
        flex-direction: column;
        background-color: var(--clr-primary);
        box-shadow: 3px 0 12px rgba(0, 0, 0, 0.25);
        transition: width 0.3s ease;
        overflow: hidden;
        z-index: 100;
    }

    .sidebar.collapsed {
        width: 65px;
    }

    /* ── Header ──────────────────────────────────────────── */
    .sidebar-header {
        display: flex;
        align-items: center;
        justify-content: space-between;
        padding: 1rem 0.75rem 1rem 1rem;
        min-height: 75px;
        flex-shrink: 0;
        border-bottom: 1px solid rgba(255, 255, 255, 0.12);
    }

    .sidebar-logo {
        max-width: 140px;
        max-height: 48px;
        object-fit: contain;
        flex-shrink: 0;
        opacity: 1;
        transition: opacity 0.2s ease, width 0.3s ease;
    }

    .sidebar.collapsed .sidebar-logo {
        opacity: 0;
        width: 0;
        pointer-events: none;
    }

    .toggle-btn {
        background: none;
        border: none;
        cursor: pointer;
        width: 34px;
        height: 34px;
        min-width: 34px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 6px;
        padding: 0;
        transition: background 0.2s;
    }

    .toggle-btn svg {
        width: 16px;
        height: 16px;
        fill: rgba(255, 255, 255, 0.75);
        transition: fill 0.2s;
    }

    .toggle-btn:hover {
        background: rgba(255, 255, 255, 0.12);
    }

    .toggle-btn:hover svg {
        fill: #fff;
    }

    .sidebar.collapsed .sidebar-header {
        justify-content: center;
    }

    /* ── Nav body ────────────────────────────────────────── */
    .sidebar-body {
        flex: 1;
        overflow-y: auto;
        overflow-x: hidden;
        padding: 0.5rem 0;
    }

    .sidebar-body::-webkit-scrollbar {
        width: 4px;
    }

    .sidebar-body::-webkit-scrollbar-track {
        background: transparent;
    }

    .sidebar-body::-webkit-scrollbar-thumb {
        background: rgba(255, 255, 255, 0.2);
        border-radius: 2px;
    }

    .sidebar-body ul {
        list-style: none;
        padding: 0;
        margin: 0;
    }

    /* ── Nav items ───────────────────────────────────────── */
    .sidebar-body ul li a,
    .group-header {
        display: flex;
        align-items: center;
        padding: 0.65rem 1rem;
        text-decoration: none;
        cursor: pointer;
        border-left: 3px solid transparent;
        transition: background 0.18s, border-color 0.18s;
        white-space: nowrap;
    }

    .sidebar-body ul li a:hover,
    .group-header:hover {
        background: rgba(255, 255, 255, 0.1);
        border-left-color: rgba(255, 255, 255, 0.5);
    }

    /* ── Icons ───────────────────────────────────────────── */
    .nav-icon {
        width: 22px;
        height: 22px;
        min-width: 22px;
        fill: rgba(255, 255, 255, 0.8);
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .nav-icon svg {
        width: 22px;
        height: 22px;
    }

    .sidebar-body ul li a:hover .nav-icon,
    .group-header:hover .nav-icon {
        fill: #fff;
    }

    /* ── Nav text ────────────────────────────────────────── */
    .nav-text {
        color: rgba(255, 255, 255, 0.88);
        font-size: 0.9rem;
        margin-left: 12px;
        flex: 1;
        overflow: hidden;
        text-overflow: ellipsis;
        transition: opacity 0.2s, max-width 0.3s;
        max-width: 180px;
    }

    .sidebar-body ul li a:hover .nav-text,
    .group-header:hover .nav-text {
        color: #fff;
    }

    .sidebar.collapsed .nav-text {
        opacity: 0;
        max-width: 0;
        margin-left: 0;
    }

    /* ── Chevron ─────────────────────────────────────────── */
    .chevron {
        width: 12px;
        height: 12px;
        min-width: 12px;
        fill: rgba(255, 255, 255, 0.45);
        margin-left: auto;
        margin-bottom: 3px;
        flex-shrink: 0;
        transition: transform 0.25s ease, opacity 0.2s;
    }

    .chevron svg {
        width: 12px;
        height: 12px;
    }

    .chevron.open {
        transform: rotate(90deg);
    }

    .group-header:hover .chevron {
        fill: rgba(255, 255, 255, 0.8);
    }

    .sidebar.collapsed .chevron {
        opacity: 0;
        width: 0;
        min-width: 0;
    }

    /* ── Sub items ───────────────────────────────────────── */
    .sidebar-body ul li.sub-item a {
        padding: 0.45rem 1rem 0.45rem 1rem;
        background: rgba(0, 0, 0, 0.15);
        border-left: 3px solid transparent;
    }

    .sidebar-body ul li.sub-item a:hover {
        background: rgba(255, 255, 255, 0.1);
        border-left-color: rgba(255, 255, 255, 0.5);
    }

    .sub-icon {
        width: 18px;
        height: 18px;
        min-width: 18px;
        fill: rgba(255, 255, 255, 0.65);
        flex-shrink: 0;
        display: flex;
        align-items: center;
        justify-content: center;
    }

    .sub-icon svg {
        width: 18px;
        height: 18px;
    }

    .sidebar-body ul li.sub-item a:hover .sub-icon {
        fill: #fff;
    }

    .sidebar-body ul li.sub-item .nav-text {
        font-size: 0.85rem;
        opacity: 0.85;
        color: rgba(255, 255, 255, 0.85);
    }

    .sidebar-body ul li.sub-item a:hover .nav-text {
        opacity: 1;
        color: #fff;
    }

    .sidebar.collapsed .sub-item {
        display: none;
    }

    /* ── Divider ─────────────────────────────────────────── */
    .nav-divider {
        height: 1px;
        background: rgba(255, 255, 255, 0.1);
        margin: 0.4rem 1rem;
    }

    .sidebar.collapsed .nav-divider {
        margin: 0.4rem 0.5rem;
    }

    /* ── Scrollbar (Firefox) ─────────────────────────────── */
    .sidebar-body {
        scrollbar-width: thin;
        scrollbar-color: rgba(255, 255, 255, 0.2) transparent;
    }

</style>
